import { ElMessageBox } from 'element-plus'
import type { Router } from 'vue-router'
import type { Composer } from 'vue-i18n'
import {
  AI_ASSISTANT_DETAIL_PATH,
  resolveAiAssistantAccessState,
} from '@/views/dashboard/service/service-subscribe/ai-assistant-detail/ai-assistant.service'
import type { PermissionMap } from '@/services/service-permission.service'
import { openQidianOnlineService } from '@/config/external-link'
import { useAideDrawerStore } from '@/stores/aide-drawer.store'

export interface HandleAideEntryOptions {
  router: Router
  permissionMap: PermissionMap
  t: Composer['t']
}

function showAiAssistantExpiredDialog (router: Router, t: Composer['t']) {
  return ElMessageBox.confirm(
    t('aide.expiredMessage'),
    t('aide.expiredTitle'),
    {
      confirmButtonText: t('aide.viewDetail'),
      cancelButtonText: t('mySubscribe.consultRenew'),
      distinguishCancelAndClose: true,
      type: 'warning',
    },
  ).then(() => {
    return router.push(AI_ASSISTANT_DETAIL_PATH)
  }).catch((action: string) => {
    if (action === 'cancel') {
      openQidianOnlineService()
    }
  })
}

/** 龙虾悬浮入口：未购→详情页；已过期→弹窗；生效中→打开抽屉 */
export function handleAideEntryClick (options: HandleAideEntryOptions) {
  const state = resolveAiAssistantAccessState(options.permissionMap)
  if (state === 'not_purchased') {
    return options.router.push(AI_ASSISTANT_DETAIL_PATH)
  }
  if (state === 'expired') {
    return showAiAssistantExpiredDialog(options.router, options.t)
  }
  const store = useAideDrawerStore()
  store.setBootEnabled(true)
  store.open()
}
